const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div style={{ padding: 20 }}>
      <h3>Something went wrong!</h3>
      <p>{error?.message || "Unknown error"}</p>
      <button onClick={resetErrorBoundary}>Retry</button>
    </div>
  );
};

export default ErrorFallback